export default {
  install(Vue) {
    Vue.prototype.$updateMetaTags = function(config) {
      // console.log('meta-manager.js - $updateMetaTags with config:', config);

      // Update title
      document.title = config.title || process.env.VUE_APP_TITLE || '';
      
      // Update meta description
      const descriptionTag = document.querySelector('meta[name="description"]');
      if (descriptionTag) {
        descriptionTag.setAttribute('content', config.description || process.env.VUE_APP_DESCRIPTION || '');
      }

      // Update meta keywords
      const keywordsTag = document.querySelector('meta[name="keywords"]');
      if (keywordsTag) {
        keywordsTag.setAttribute('content', config.keywords || process.env.VUE_APP_KEYWORDS || '');
      }

      // Update Twitter meta tags
      const twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) {
        twitterTitle.setAttribute('content', config.title || process.env.VUE_APP_TITLE || '');
      }

      const twitterDesc = document.querySelector('meta[name="twitter:description"]');
      if (twitterDesc) {
        twitterDesc.setAttribute('content', config.description || process.env.VUE_APP_DESCRIPTION || '');
      }

      // Update OpenGraph meta tags
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.setAttribute('content', config.title || process.env.VUE_APP_TITLE || '');
      }

      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) {
        ogDesc.setAttribute('content', config.description || process.env.VUE_APP_DESCRIPTION || '');
      }

      // Update favicon if provided
      if (config.favicon) {
        const links = document.querySelectorAll("link[rel~='icon']");
        if (links.length > 0) {
          links.forEach(link => {
            link.href = config.favicon;
          });
        } else {
          // If no favicon link exists, create one
          const link = document.createElement('link');
          link.rel = 'icon';
          link.type = 'image/x-icon';
          link.href = config.favicon;
          document.head.appendChild(link);
        }
      }

      // Update Google site verification if provided
      if (config.googleSiteVerification) {
        let verificationTag = document.querySelector('meta[name="google-site-verification"]');
        if (verificationTag) {
          verificationTag.setAttribute('content', config.googleSiteVerification);
        } else {
          verificationTag = document.createElement('meta');
          verificationTag.setAttribute('name', 'google-site-verification');
          verificationTag.setAttribute('content', config.googleSiteVerification);
          document.head.appendChild(verificationTag);
        }
      }
    };
  }
}; 